import React from 'react';
import PropTypes from 'prop-types';
import PostExcerpt from './PostExcerpt';

const PostExcerptList = props => {
  const { posts } = props;

  return <div>{posts.map(post => <PostExcerpt post={post} key={post.id} />)}</div>;
};

PostExcerptList.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
};

PostExcerptList.defaultProps = {
  posts: [],
};

export default PostExcerptList;



// WEBPACK FOOTER //
// ./src/components/PostExcerptList.js